export const CORES_SITE = {

  VERMELHO_PRIMARY: '#8d0202',
  VERMELHO_ESCURO: '#7f1d1d',
  PRETO_TEXT: '#000000',
  AMARELO_DESTAQUE: '#ea580c',
  
  CINZA_DARK: '#1F2937',
  CINZA_ESCURO: '#374151',
  CINZA_MEDIO: '#6b7280',
  CINZA_TEXT: '#6b7280',
  CINZA_CLARO: '#9CA3AF',
  CINZA_LIGHT: '#f3f4f6',
  CINZA_BORDER: '#e5e7eb',
  
  BRANCO: '#ffffff',
  VERDE_SUCESSO: '#059669',
  VERDE_CLARO: '#10b981',
} as const;

export const TIPOGRAFIA = {
  // Hierarquia de títulos
  TITULO_PRINCIPAL: 'text-2xl font-bold text-gray-900',
  TITULO_SECAO: 'text-xl font-semibold text-gray-900 mb-3',
  SUBTITULO: 'text-base font-medium text-gray-700',
  
  // Corpo de texto
  CORPO: 'text-sm text-gray-700',
  CORPO_SECUNDARIO: 'text-sm text-gray-600',
  LEGENDA: 'text-xs text-gray-500',
  MICRO: 'text-xs text-gray-400',
  
  // Casos específicos de valores/métricas
  VALOR_DESTAQUE_GRANDE: 'text-3xl font-bold text-gray-900',
  VALOR_DESTAQUE_MEDIO: 'text-2xl font-bold text-gray-900',
  VALOR_DESTAQUE_PEQUENO: 'text-xl font-bold text-gray-900',
  PERCENTUAL_GRANDE: 'text-3xl font-bold',
  PERCENTUAL_MEDIO: 'text-2xl font-bold',
  
  // Textos explicativos (uso em seções)
  SUBTITULO_EXPLICATIVO: 'text-sm text-gray-600 text-center mb-4',
  TEXTO_APOIO: 'text-xs text-gray-500 text-center mt-2',
  
  // Labels e categorias
  LABEL_PEQUENO: 'text-xs font-medium text-gray-600',
  LABEL_MEDIO: 'text-sm font-medium text-gray-700',
  
  // Tags e badges
  TAG_BASE: 'text-xs font-semibold px-2 py-1 rounded-full',
} as const;

export const CONTAINERS = {
  // Cards básicos
  CARD_BASE: 'bg-white border border-gray-200 rounded-lg',
  CARD_HOVER: 'bg-white border border-gray-200 rounded-lg hover:border-gray-300 transition-colors',
  CARD_DESTAQUE: 'bg-white border-2 border-red-700 rounded-lg shadow-sm',
  
  // Seções e fundos
  SECAO_FUNDO_NEUTRO: 'bg-gray-50 border border-gray-200 rounded-lg',
  SECAO_FUNDO_BRANCO: 'bg-white border border-gray-200 rounded-lg',
  
  // Destaque especial do usuário
  DESTAQUE_USUARIO: 'bg-orange-50 border-l-4 border-orange-500',
} as const;

export const BORDAS_DESTAQUE = {
  // Bordas laterais para hierarquia visual (substitui fundos coloridos)
  VERMELHO: 'border-l-4 border-red-700',
  DOURADO: 'border-l-4 border-orange-500',
  VERDE: 'border-l-4 border-green-600',
  CINZA: 'border-l-4 border-gray-400',
} as const;

export const ESPACAMENTO = {
  // Espaçamento entre seções principais
  ENTRE_SECOES: 'mb-8',
  ENTRE_SECOES_GRANDE: 'mb-12',
  
  // Padding interno de containers
  CARD_PADDING_PEQUENO: 'p-3',
  CARD_PADDING: 'p-4',
  CARD_PADDING_GRANDE: 'p-6',
  
  // Margens de gráficos
  GRAFICO_MARGIN: 'mb-6',
  
  // Gaps em grids e flexbox
  GAP_PEQUENO: 'gap-2',
  GAP_MEDIO: 'gap-4',
  GAP_GRANDE: 'gap-6',
} as const;

export const SOMBRAS = {
  // Sistema de elevação
  NENHUMA: 'shadow-none',
  SUTIL: 'shadow-sm',
  MEDIA: 'shadow-md',
  ELEVADA: 'shadow-lg',
} as const;

export const TRANSICOES = {
  // Animações padrão
  PADRAO: 'transition-all duration-200 ease-in-out',
  RAPIDA: 'transition-all duration-150 ease-in-out',
  SUAVE: 'transition-all duration-300 ease-in-out',
  LENTA: 'transition-all duration-500 ease-in-out',
} as const;

export const ESTADOS_INTERATIVOS = {
  // Hover states
  HOVER_ELEVACAO: 'hover:shadow-md transition-shadow',
  HOVER_BORDA: 'hover:border-gray-300 transition-colors',
  HOVER_FUNDO: 'hover:bg-gray-50 transition-colors',
  
  // Focus states
  FOCUS_RING: 'focus:outline-none focus:ring-2 focus:ring-red-700 focus:ring-offset-2',
} as const;

// Utilitários de cor contextual para tags/badges
export const TAG_CORES = {
  MUITO_ACIMA: 'border-green-600 text-green-700 bg-green-50',
  ACIMA: 'border-green-500 text-green-600 bg-green-50',
  PROXIMO: 'border-yellow-500 text-yellow-700 bg-yellow-50',
  MODERADO: 'border-orange-500 text-orange-700 bg-orange-50',
  DISTANTE: 'border-red-500 text-red-700 bg-red-50',
} as const;